import ABCyaPhaser from "@abcya/abcya_phaser";
import AScene from "../../library/ExtendedObjects/AScene.js"
import { ReturnToTray } from "../Tabs/TrayItemsClickedActions/ReturnToTray.js";
import { TreeTab } from "../Tabs/TreeTab.js"
import { onBackGroundButtonClicked } from "./ButtonClickHandlers/onBackGroundButtonClicked.js";
import { onCloseTrayButtonClicked } from "./ButtonClickHandlers/onCloseTrayButtonClicked.js";
import { onMuteButtonClicked } from "./ButtonClickHandlers/onMuteButtonClicked.js";
import { OnPrintSaveClickHandler } from "./ButtonClickHandlers/onSavePrintButtonsClicked.js";
import { onStartOverButtonClicked } from "./ButtonClickHandlers/onStartOverButtonClicked.js";
import { onUndoButtonClicked } from "./ButtonClickHandlers/onUndoButtonClicked.js";
import { CreateSoundLib } from "./CreateSoundLib.js";
import { CreateHelpMessage } from "./HelpMessages.js";
import { SceneWideInputSetUpCall } from "./InputEvents.js";
import { CreateDepth } from "./IntroDepthList.js"
import { TabSwitcher } from "./TabSwitcher.js"
import { ChangeBackGroundFadeIn, GroupTraySlide, TabTween, ToggleTrayItems, TweenInButtons } from "./TweensFile.js";
import FontKeys from "../../FontKeys.js";
import ABCyaLib from "@abcya/abcya_lib";

export default class Intro extends AScene
{
    static get KEY() { return 'Game'; }

    create()
    {
        ////console.log(this);
        this.Tray; //used for width calculations across all tabs. Created in placemenuitems on this page
        this.OrnamentTitle = this.add.container(this.mid.x+64,this.mid.y);
        this.AudioChan = CreateSoundLib(this);

        this.CleanUpHelp;
        
        //Tween Ref
        this.HelpBtn;
        this.CloseTrayBtn;
        this.ChangeButtons;
        this.ChangeBackGroundMaskLeft;
        this.ChangeBackGroundMaskRight;
        this.MenuButtons;
        this.HelpMessage;

        this.BackGrndObj2;

        this.BackCont1 = this.add.container(0,0);
        this.BackCont2 = this.add.container(0,0);

        this.BackCont1.setData( {
            Sky: this.addImage(693,204, "Mod_Sky",this.BackCont1),
            BackGround: this.addImage(this.mid.x+63, this.mid.y, "BG_Stripes",this.BackCont1),
            FirePlace: this.addImage(309,410, "Mod_Frplc",this.BackCont1),
            Wreath: this.addImage(309,110, "Mod_Wrth",this.BackCont1),
            Stocking: this.addImage(361,344, "Mod_Stckng",this.BackCont1),
            CurtainsRt: this.addImage(837+8,263-248, "Mod_CrtnRt",this.BackCont1),
            CurtainsLt: this.addImage(554-7,263-248, "Mod_CrtnRt",this.BackCont1),
            //CurtainsLt: this.add.rope(554,263-248, "Mod_CrtnRt"),
            // TiesRt: this.addImage(887+50,334-319, "Mod_TiesRt",this.BackCont1),
            // TiesLt: this.addImage(504-103,334-319, "Mod_TiesRt",this.BackCont1),
            FireWood: this.addImage(309, 519,"Fire_Wd",this.BackCont1),
            Fire2: this.addImage(276, 473+33,"Fire_Flm2",this.BackCont1),
            Fire3: this.addImage(342, 475+33,"Fire_Flm3",this.BackCont1),
            Fire1: this.addImage(309, 461+45,"Fire_Flm1",this.BackCont1)
        });

        this.BackCont2.setData({
            Sky: this.addImage(693,204, "Mod_Sky",this.BackCont2),
            BackGround: this.addImage(this.mid.x+63, this.mid.y, "BG_Stripes",this.BackCont2),
            FirePlace: this.addImage(309,410, "Mod_Frplc",this.BackCont2),
            Wreath: this.addImage(309,110, "Mod_Wrth",this.BackCont2),
            Stocking: this.addImage(361,344, "Mod_Stckng",this.BackCont2),
            CurtainsRt: this.addImage(837+8,263-248, "Mod_CrtnRt",this.BackCont2),
            CurtainsLt: this.addImage(554-7,263-248, "Mod_TiesRt",this.BackCont2),
            // TiesRt: this.addImage(887+50,334-319, "Mod_CrtnRt",this.BackCont2),
            // TiesLt: this.addImage(504-103,334-319, "Mod_TiesRt",this.BackCont2),
            FireWood: this.addImage(309, 519,"Fire_Wd",this.BackCont2),
            Fire2: this.addImage(276, 473+33,"Fire_Flm2",this.BackCont2),
            Fire3: this.addImage(342, 475+33,"Fire_Flm3",this.BackCont2),
            Fire1: this.addImage(309, 461+45,"Fire_Flm1",this.BackCont2)
        });

        this.BackCont2.bringToTop(this.BackCont2.getData('BackGround'));

        // this.BackCont1.getData('TiesLt').flipX = true;
        // this.BackCont2.getData('TiesLt').flipX = true;

        this.BackCont1.getData('CurtainsRt').flipX = true;
        this.BackCont2.getData('CurtainsRt').flipX = true;

        this.BackCont1.getData('Stocking').setOrigin(.5,0);
        this.BackCont2.getData('Stocking').setOrigin(.5,0);

        this.BackCont1.getData('CurtainsRt').setOrigin(.5,0);
        this.BackCont1.getData('CurtainsLt').setOrigin(.5,0);
        this.BackCont2.getData('CurtainsRt').setOrigin(.5,0);
        this.BackCont2.getData('CurtainsLt').setOrigin(.5,0);

        this.BackCont1.getData('Fire1').setOrigin(.5,1);
        this.BackCont1.getData('Fire2').setOrigin(.5,1);
        this.BackCont1.getData('Fire3').setOrigin(.5,1);
        this.BackCont2.getData('Fire1').setOrigin(.5,1);
        this.BackCont2.getData('Fire2').setOrigin(.5,1);
        this.BackCont2.getData('Fire3').setOrigin(.5,1);

        this.CurrentBack = this.BackCont2;
        this.NewBack = this.BackCont1;

        this.LightDragOffset = "Empty";
        this.TreeForceBox;//used to overlay all the Tabs before a tree is selected
        this.HelpPopUp = false;

        this.DepthList= CreateDepth();//used for depth reference across all tabs

        this.BackCont1.setDepth(this.DepthList.Background);
        this.BackCont2.setDepth(this.DepthList.Background);

        this.PSTextMask1;//Print Save Text mask - used in print save
        this.PSTextMask2;

        this.BackLog = [];//Used for back button

        this.PlaceBool = false;//hit box check variable used in tabswitcher
        this.IntitialCheck = false;//used for placement in tabswitcher
        this.HitBoxTree;//used for hitbox tree in Tabswitcher
        //this.HitBox;
        this.DragObject;//Used for initial place checking. When setting something as a drag target manually it does not fire dragend
        //^it does not fire dragstart either
        this.DrawState = false;//used in DecorClickHandler to determine when drawing or when placing items

        this.CurrentTabName = 'Trees';//Tab switcher data
        this.CurrentTab;//Reference to current tab image

        this.ActiveTree;//Used for Tree Tab
        this.ActiveTreeTop;//Used for Tree Topper Tab

        this.SelectedBackGround = 0;//Used in ButtonClickHandlers for background selection
        
        this.LightsBlinking = false;//used in Light tab to determine which button is selected. False is intial value

        this.OnTreeGroup = this.add.group();//Used for Start over
        this.BackGroundGroup = this.add.group();//Used for all the parts of the Backgrounds to easily clear them
        this.ColorGroup = this.add.group();//group for any tab that changes color
        this.TrayGroup = this.add.group();//group for any tab items that appear on tray
        this.OutlineGroup = this.add.group();//group for selection back drop. Only used in Light tab and decor tab
        this.LightGroup = this.add.group();//group for all placed lights. Populated by Tabswitcher, used in lightclickhandler to change from solid to blinking 
        this.GiftGroup = this.add.group();// used in Trayplacementtools and gift click handler

        let LineStart = this.BackCont1.getData('Sky').getTopLeft();
        let LineEnd = this.BackCont1.getData('Sky').getTopRight();
        let LineZone = new Phaser.Geom.Line(LineStart.x,LineStart.y,LineEnd.x,LineEnd.y);
        //onBackGroundButtonClicked(this);
        
        SceneWideInputSetUpCall(this);
        this.PlaceMenuItems(); 
        //this.StartEvents();
        

        var particles1 = this.add.particles('UIAssets');
        var particles2 = this.add.particles('UIAssets');

        var Emitter1 = particles1.createEmitter();
        //LineZone.Depth = (this.DepthList.BackgroundAssets);
        Emitter1.setFrame('Grlnd_Ball_Wht');
        Emitter1.setEmitZone({source: LineZone,type:'edge',quantity:10,yoyo:false});
        Emitter1.setRadial(true);
        Emitter1.setLifespan(4500);
        Emitter1.setGravity(0,10);
        Emitter1.setAngle({min:45,max:135});
        //Emitter1.setPosition(800, 300);
        Emitter1.setSpeed(60);

        var Emitter2 = particles2.createEmitter();
        //LineZone.Depth = (this.DepthList.BackgroundAssets);
        Emitter2.setFrame('Grlnd_Ball_Wht');
        Emitter2.setEmitZone({source: LineZone,type:'edge',quantity:10,yoyo:false});
        Emitter2.setRadial(true);
        Emitter2.setLifespan(4500);
        Emitter2.setGravity(0,10);
        Emitter2.setAngle({min:45,max:135});
        //Emitter2.setPosition(800, 300);
        Emitter2.setSpeed(60);

        Emitter1.pause();
        Emitter2.pause();
        this.BackCont1.setData({Emit:Emitter1});
        this.BackCont2.setData({Emit:Emitter2});

        this.BackCont1.add(particles1);
        this.BackCont1.moveTo(particles1,0);
        this.BackCont1.sendToBack(this.BackCont1.getData('Sky'));

        this.BackCont2.add(particles2);
        this.BackCont2.moveTo(particles2,0);
        this.BackCont2.sendToBack(this.BackCont2.getData('Sky'));

        this.DrawArray = [{Name: "Temp",tint:""},{tint:""}];//used for draw tools in tabswitcher for lights and garlands
        this.DrawDistance;//used by draw tools in tab switcher, distance between placed objects
        this.DrawCounter = 1; //used by draw tools in tab switcher, used in drawarray to determine which asset is placed next

        const nameText = document.createElement('input');
        const messageText = document.createElement('input');
        const wrapper = document.getElementById('contentWrapper');

        //this.input.keyboard.on('keydown', event => {console.log(event.code)})

        nameText.setAttribute('id','nametext');
        nameText.setAttribute('type','text');
        nameText.setAttribute('style','position: absolute; top: -29%;');

        messageText.setAttribute('id','messagetext');
        messageText.setAttribute('type','text');
        messageText.setAttribute('style','position: absolute; top: -29%;');

        wrapper.appendChild(nameText);
        wrapper.appendChild(messageText);

        this.input.keyboard.on(Phaser.Input.Keyboard.Events.KEY_DOWN + "LEFT", (e)=>{
          e.preventDefault();
        });

        this.input.keyboard.on(Phaser.Input.Keyboard.Events.KEY_DOWN + "RIGHT", (e)=>{
          e.preventDefault();
        });

        this.input.keyboard.on(Phaser.Input.Keyboard.Events.KEY_DOWN + "UP", (e)=>{
          e.preventDefault();
        });

        this.input.keyboard.on(Phaser.Input.Keyboard.Events.KEY_DOWN + "DOWN", (e)=>{
          e.preventDefault();
        });

        this.input.keyboard.on(Phaser.Input.Keyboard.Events.KEY_DOWN + "TAB", (e)=>{
          e.preventDefault();
        });


        //console.log(document);

        //this.input.on('pointerdown',(pointer)=>{//console.log(`${pointer.x}, ${pointer.y}`)});
    }

    PlaceMenuItems()
    {
        //this.addImage(this.mid.x+63, this.mid.y, "BG_Stripes");
        //this.addImage(this.mid.x+63, this.mid.y, "Mod_BG");

        const Title = [];
        const TrayButtons = [];

        this.HelpMessage = this.add.container(389, 87);
        const bg = this.addImage(0,0, "Notif_Help", this.HelpMessage).setOrigin(0, 0.5);
        const txt = ABCyaPhaser.Text.addText(194,-5,24, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("help_instructions"), this.HelpMessage).setWordWrapWidth(250);
        this.HelpMessage.setScale(0);

        this.OrnamentTitle.setDepth(this.DepthList.BackgroundAssets);
        
        Title[0] = this.addImage(0, 0, "Title_Orn",this.OrnamentTitle, ABCyaPhaser.Images.LOCALIZATION_ATLAS);

        let size = 20;
        TrayButtons[0] = this.add.container(64, 63, [
          ABCyaPhaser.Images.addImage(0,0, "Btn_Trees", this),
          ABCyaPhaser.Text.addText(0,48,size, 0x038415, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("tree_menu.name"), this)
        ]);

        size = ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? 17 : 18;
        TrayButtons[1] = this.add.container(64, 191, [
          ABCyaPhaser.Images.addImage(0,0, "Btn_Grlnd", this),
          ABCyaPhaser.Text.addText(0,40,size, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("garland_menu.name"), this).setLineSpacing(-3)
        ]);

        size = 20;
        TrayButtons[2] = this.add.container(64, 319, [
          ABCyaPhaser.Images.addImage(0,0, "Btn_Lts", this),
          ABCyaPhaser.Text.addText(0,48,size, 0xffd400, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("lights_menu.name"), this)
        ]);

        TrayButtons[4] = this.add.container(64, 447, [
          ABCyaPhaser.Images.addImage(0,0, "Btn_Orn", this),
          ABCyaPhaser.Text.addText(0,48,size, 0x80f98f, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("ornaments_menu.name"), this)
        ]);

        size = ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS ? 14 : 20;
        TrayButtons[5] = this.add.container(64, 575, [
          ABCyaPhaser.Images.addImage(0,0, "Btn_TreTpr", this),
          ABCyaPhaser.Text.addText(0,48,size, 0xffd400, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("tree_topper_menu.name"), this)
        ]);

        size = 20;
        TrayButtons[6] = this.add.container(64, 703, [
          ABCyaPhaser.Images.addImage(0,0, "Btn_Gfts", this),
          ABCyaPhaser.Text.addText(0,48,size, 0xc90505, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("gifts_menu.name"), this)
        ]);
 
        this.TrayButtons = TrayButtons;

        this.Tray = this.addImage(22, 384, "Tray").setVisible(false);//Intitial placement
        this.Tray.setInteractive();
        this.Tray.setDepth(this.DepthList.Tray);
        this.OrnamentTitle.setScale(.5);

        for(let x in TrayButtons)
        {
            const bg = TrayButtons[x].getAt(0);
            TrayButtons[x].setSize(bg.width, bg.height);
            //TrayButtons[x].setInteractive();
            //TrayButtons[x].on('pointerdown',TabSwitcher);
            TrayButtons[x].setDepth(this.DepthList.Buttons);
        }
        
        const OrnTween = this.addTween(this.OrnamentTitle, 800, {scale:{start:0,to:1}},Phaser.Math.Easing.Quadratic.InOut,()=>{
            this.StartEvents();
        });

        OrnTween.on("start",()=>{
            this.sound.playAudioSprite('gameAudio','title_tween');
        })
    }

    StartEvents()
    {
        //This handles the first onlick to get rid of title and start animations

        //this.input.once('pointerdown',()=>{
            this.addTween(this.OrnamentTitle, 800, {scale:0,delay:400},Phaser.Math.Easing.Quadratic.InOut,()=>{
            this._PlaceButtons();
            this.Tray.setVisible(true);
            this.CurrentTab = this.addImage(132, 62, "Btn_Trees_Bmp").setDepth(this.DepthList.OrnBack);
            TreeTab(this,this.Tray);

            //TraySlideOut(this,this.Tray);
            GroupTraySlide(this.TrayGroup, "Out");
            this._createTreeForceBox();

            //this.addImage(133, 191, "Btn_Grlnd_Bmp");
            //DecorTab(this,this.Tray);
            //this.addImage(133,319,"Btn_Lts_Bmp");
            //LightTab(this,this.Tray);
            //this.addImage(133,447,"Btn_Orn_Bmp");
            //OrnamentTab(this,this.Tray);
            //this.addImage(133,575, "Btn_TreTpr_Bmp");
            //TreeTopTab(this,this.Tray);
            //this.addImage(133,703, "Btn_Gfts_Bmp");
            //GiftTab(this,this.Tray);
        //});
    });
    }

    _PlaceButtons()
    {
        const UndoBtn = this.add.container(970, 48);
        const undoBtnBg = this.addImage(0,0,"Btn_Undo", UndoBtn).setScale(.898);
        UndoBtn.setSize(undoBtnBg.width, undoBtnBg.height);
        ABCyaPhaser.Container.setContainerInteractive(UndoBtn, false);
        const undoBtnTxt = ABCyaPhaser.Text.addCurvedText(0,0,12, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("undo_button"), undoBtnBg.width/2-15, UndoBtn, 90 * Phaser.Math.DEG_TO_RAD, 1, false, true);
        undoBtnTxt.letterTextFields.forEach(tf => tf.setResolution(1.5));

        const SaveBtn = this.add.container(970, 136);
        const saveBtnBg = this.addImage(0,0,"Btn_Save", SaveBtn).setScale(.898);
        SaveBtn.setSize(saveBtnBg.width, saveBtnBg.height);
        ABCyaPhaser.Container.setContainerInteractive(SaveBtn, false);
        const saveBtnTxt = ABCyaPhaser.Text.addCurvedText(0,0,12, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("save_button"), saveBtnBg.width/2-15, SaveBtn, 90 * Phaser.Math.DEG_TO_RAD, 1, false, true);
        saveBtnTxt.letterTextFields.forEach(tf => tf.setResolution(1.5));

        const PrintBtn = this.add.container(970, 224);
        const printBtnBg = this.addImage(0,0,"Btn_Prnt", PrintBtn).setScale(.898);
        PrintBtn.setSize(printBtnBg.width, printBtnBg.height);
        ABCyaPhaser.Container.setContainerInteractive(PrintBtn, false);
        const printBtnTxt = ABCyaPhaser.Text.addCurvedText(0,0,12, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("print_button"), printBtnBg.width/2-15, PrintBtn, 90 * Phaser.Math.DEG_TO_RAD, 1, false, true);
        printBtnTxt.letterTextFields.forEach(tf => tf.setResolution(1.5));

        const StartOverBtn = this.add.container(970, 312);
        const startOverBtnBg = this.addImage(0,0,"Btn_StrtOvr", StartOverBtn).setScale(.898);
        StartOverBtn.setSize(startOverBtnBg.width, startOverBtnBg.height);
        ABCyaPhaser.Container.setContainerInteractive(StartOverBtn, false);
        const startOverBtnTxt = ABCyaPhaser.Text.addCurvedText(0,0,12, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("start_over_button"), startOverBtnBg.width/2-12, StartOverBtn, 90 * Phaser.Math.DEG_TO_RAD, 1, false, true);
        startOverBtnTxt.letterTextFields.forEach(tf => tf.setResolution(1.5));

        const MuteButton = this.add.container(970, 400);
        const muteBtnBg = this.addImage(0,0,"Btn_SndOn", MuteButton).setScale(.898);
        MuteButton.setSize(muteBtnBg.width, muteBtnBg.height);
        ABCyaPhaser.Container.setContainerInteractive(MuteButton, false);
        const muteBtnTxt = ABCyaPhaser.Text.addCurvedText(0,0,12, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("sound_on_button"), muteBtnBg.width/2-15, MuteButton, 90 * Phaser.Math.DEG_TO_RAD, 1, false, true);
        muteBtnTxt.letterTextFields.forEach(tf => tf.setResolution(1.5));

        this.CloseTrayBtn = this.addImage(this.Tray.getTopRight().x+19,27,"Btn_ClsTray").setDepth(this.DepthList.Buttons);
        this.HelpBtn  = this.addImage(this.Tray.getTopRight().x + 19,81,"Btn_Help").setDepth(this.DepthList.Buttons);

        this.CloseTrayBtn.setScale(1,0);
        this.HelpBtn.setScale(1,0);

        this.CloseTrayBtn.setInteractive();
        this.HelpBtn.setInteractive();

        const ChangeRightBtn = this.addImage(996,738,"Btn_ChngBG_Arw");
        const ChangeLeftBtn = this.addImage(868,737,"Btn_ChngBG_Arw").setAngle(180);
        const ChangeBackGround = this.add.container(932, 738, [
          this.add.rectangle(0,-1,101,39, 0x045613),
          ABCyaPhaser.Text.addText(0,-1,14, 0xffffff, FontKeys._ffulbotano, ABCyaPhaser.Localization.instance.getLocalizedString("change_background_label"), this).setLineSpacing(-4).setResolution(2)
        ]).setDepth(this.DepthList.Buttons).setSize(101,41);

        this.MenuButtons = [UndoBtn,SaveBtn,PrintBtn,StartOverBtn,MuteButton];
        const ChangeButtons = [ChangeLeftBtn,ChangeRightBtn];

        for(let x in ChangeButtons)
        {
            ChangeButtons[x].setInteractive();
            ChangeButtons[x].setDepth(this.DepthList.ArrowBtn);
            ChangeButtons[x].setAlpha(0);
        }

        for(let x in this.MenuButtons)
        {
            this.MenuButtons[x].setInteractive();
            this.MenuButtons[x].setDepth(this.DepthList.Buttons);
            this.MenuButtons[x].x+=279.5935;
        }

        this.ChangeButtons = ChangeButtons;
        this._createMasks(ChangeBackGround);
        //console.log(this.ChangeButtons);

        //TweenInButtons(this.MenuButtons,500);

        this.CloseTrayBtn.on('pointerdown',()=>{
            ToggleTrayItems(this.TrayGroup,false);
            GroupTraySlide(this.TrayGroup,"In");
            TabTween(this,this.HelpBtn,"In");
            TabTween(this,this.CloseTrayBtn,"In");
            this.ButtonStandard();
        });
        SaveBtn.on('pointerdown',()=>{
            OnPrintSaveClickHandler(this,"Save");
            this.ButtonStandard(SaveBtn);
        });
        PrintBtn.on('pointerdown',()=>
        {
            OnPrintSaveClickHandler(this,"Print");
            this.ButtonStandard(PrintBtn);
        });
        this.HelpBtn.on('pointerup',()=>
        {
            CreateHelpMessage(this,this.CurrentTabName);
            this.ButtonStandard(this.HelpBtn);
        });
        StartOverBtn.on('pointerdown',()=>
        {
            onStartOverButtonClicked(this);
            this.ButtonStandard(StartOverBtn);
        });
        ChangeRightBtn.on('pointerdown',()=>
        {
            onBackGroundButtonClicked(this,"Right",ChangeButtons);
            this.ButtonStandard();
        });
        ChangeLeftBtn.on('pointerdown',()=>
        {
            onBackGroundButtonClicked(this,"Left",ChangeButtons);
            this.ButtonStandard();
        });
        UndoBtn.on('pointerdown',()=>
        {
            onUndoButtonClicked(this,UndoBtn);
        });
        MuteButton.on('pointerdown',()=>
        {
            onMuteButtonClicked(this,MuteButton);
            this.ButtonStandard(MuteButton);
        });
    }

    /**
     * 
     * @param {Phaser.GameObjects.Container} ChangeBackGround 
     */
    _createMasks(ChangeBackGround)//This is for the change background tween in
    {
        let ChangeBackgroundBounds = ChangeBackGround.getBounds();
        let TopCenter = new Phaser.Math.Vector2(ChangeBackgroundBounds.left + ChangeBackgroundBounds.width/2, ChangeBackgroundBounds.top);

        this.ChangeBackGroundMask = this.add.rectangle(ChangeBackgroundBounds.centerX,ChangeBackgroundBounds.centerY,ChangeBackGround.width, ChangeBackGround.height, 0xff0000).setVisible(false).setScale(0, 1).setDepth(10000);

        this.ChangeButtons[0].x = TopCenter.x - (this.ChangeButtons[0].width*.5)+2;
        this.ChangeButtons[1].x = TopCenter.x + (this.ChangeButtons[0].width*.5)-2;

        let MaskShape = this.ChangeBackGroundMask.createBitmapMask(this.ChangeBackGroundMask);

        ChangeBackGround.setMask(MaskShape);
    }

    _createTreeForceBox()//this creates the initial start state
    {
        let Width = this.TrayButtons[1].width;
        let Height = 768;
        let TopLeft = this.TrayButtons[1].getBounds();

        this.TreeForceBox = this.add.rectangle(TopLeft.x,TopLeft.y,Width,Height,0x000000,.5);
        this.TreeForceBox.setOrigin(0,0);
        this.TreeForceBox.setDepth(this.DepthList.ArrowBtn);
        this.TreeForceBox.setAlpha(0);
        this.TreeForceBox.setInteractive({alwaysEnabled:true});
        this.TreeForceBox.on('pointerdown',()=>{CreateHelpMessage(this,'Trees')});

        this.addTween(this.TreeForceBox,200,{alpha:1},Phaser.Math.Easing.Quadratic.InOut);
    }
    
    ButtonStandard(Button)
    {
        this.AudioChan.Chan5.play('click_in_game');
        if(Button)
        {
            Button.disableInteractive();
            this.addTween(Button,100,{scale:.798,yoyo:true},Phaser.Math.Easing.Linear,()=>
            {
                Button.setInteractive();
            });
        }
    }
}